const ADMIN_PAGE_CODE = {
  ADMIN_SEARCH_LISTING: "ADMIN_SEARCH_LISTING",
  ADMIN_ESTIMATE_PAGE: "ADMIN_ESTIMATE_PAGE",
  ADMIN_USERS_PAGE: "ADMIN_USERS_PAGE",
  ADMIN_BIDDING_PAGE: "ADMIN_BIDDING_PAGE",
  SITE_MANAGER: "SITE_MANAGER",
  ADMIN_AGREEMENTS: "ADMIN_AGREEMENTS",
};

export default {
  HOME: "home",
  FARMER: "FARMER",
  FARMER_SEARCH_RESULT: "FARMER_SEARCH_RESULT",
  SUCCESS_AGREEMENT: "SUCCESS_AGREEMENT",
  LANDOWNER: "Landowner",
  ALLIANCE_PARTNERS: "alliance-partners",
  CREATE_LISTING: "my-estimate",
  FREE_ESTIMATE: "FREE_ESTIMATE",
  TERMS_AND_CONDITIONS: "TERMS_AND_CONDITIONS",
  PRIVATE_POLICY: "PRIVATE_POLICY",
  CASHRENT_ESTIMATE: "CASHRENT_ESTIMATE",
  MY_LISTING: "my-listing",
  MY_MAPPING: "my-mapping",
  CONTACT_US: "contact-us",
  ABOUT_US: "about-us",
  THANK_YOU: "THANK_YOU",
  FIND_FARM_FOR_LEASE: "FIND_FARM_FOR_LEASE",
  ILLINOIS_FARM_LAND_FOR_RENT: "ILLINOIS_FARM_LAND_FOR_RENT",
  IOWA_FARM_LAND_FOR_RENT: "IOWA_FARM_LAND_FOR_RENT",
  FIND_A_FARMER: "FIND_A_FARMER",
  HOW_TO_LEASE_LANDFARM: "HOW_TO_LEASE_LANDFARM",
  MY_LISTING_DETAIL: "my-listing-detail",
  MY_PROFILE: "my-profile",
  BIDDING_DETAILS: "bidding-details",
  BIDDING_REVIEW_AGREEMENT: "bidding-review-agreement",
  BIDDING_PREVIEW_CONTRACT: "bidding-preview-agreement",
  BIDDING_SIGN_CONTRACT: "bidding-sign-agreement",
  BIDDING_NEW: "bidding",
  BIDDING_GUEST_SIGN: "bidding-sign",
  LAND_TERMS: "terms-conditions",
  LAND_DETAIL: "land-detail",
  FARM_OVERVIEW: "farm-overview",
  FARM_FIELDS: "farm-fields",
  FARM_ESTIMATE: "farm-estimate",
  FARM_LEASES: "farm-leases",
  FARM_MAPS: "farm-maps",
  FARM_CREATE: "farm-create",
  FIELD_DETAIL: "field-detail",
  DASHBOARD_DASHBOARD: "dashboard",
  DASHBOARD_FARMS: "farms",
  DASHBOARD_LISTINGS: "listings",
  DASHBOARD_LEASES: "leases",
  DASHBOARD_SETTINGS: "settings",
  DASHBOARD_PAYMENTS: "payments",
  DASHBOARD_MY_BID: "dashboard-my-bid",
  DASHBOARD_MY_WATCH_ITEMS: "dashboard-my-watch-items",
  BLOGS: "blogs",
  BLOG_DETAIL: "blog-detail",
  PRESS: "press",
  ...ADMIN_PAGE_CODE,
};
